export default __webpack_public_path__ + "static/media/emlak-mortgage-logo.017f85d4.png";